export const VALIDATION_MESSAGES = {
  required: 'Preenchimento obrigatório.',
  email: 'Informe um endereço de e-mail válido.',
  maxLenght: 'Valor inválido.',
  phoneNumber: 'Número de telefone inválido.',
  passwordMismatch: 'Senhas devem ser iguais.',
  passwordLength: 'Senha deve conter ao menos 8 caracteres.',
  cnpj: 'CNPJ é inválido.',
};
